export const NOT_AUTHORIZED = 401;
export const FORBIDDEN = 403;
export const NOT_FOUND = 404;
export const BAD_REQUEST = 400;
export const SERVICE_UNAVAILABLE = 503;
export const SERVER_ERROR = 500;
